module.exports = __webpack_public_path__ + "static/img/p-31.e590bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-31.png
// module id = EIxo
// module chunks = 0